import { useQuery } from "react-query";
import { useState } from "react";
import MainCard from "../../components/layout/MainCard/MainCard";
import LoadingWrapper from "../../components/Loading/LoadingWrapper";
import useAPI from "../../hooks/useAPI";
import { GlobalQueries } from "../../hooks/useRefreshQuery";
import ProductItems from "../Catalogue/Products/ProductItems/ProductItems";
import scss from "./WishlistPage.module.scss";
import { useTranslation } from "react-i18next";
import SidebarHeader from "../../components/layout/WithFixedSidebar/SidebarHeader/SidebarHeader";
import icons from "helpers/icons";
import EmptyState from "components/Empty/EmptyState";
import SearchBar from "components/UI/SearchBar";

/**
 * Show the user's wishlist.
 */
const WishlistPage = () => {
    const { t } = useTranslation();
    const [search, setSearch] = useState("");
    const api = useAPI();
    // Load all products in the cart
    const { data, isLoading } = useQuery([GlobalQueries.Wishlist], () => api.list(`/wishlist`));
    const items = data?.items?.map((item) => ({ ...item, quantity: Math.floor(item.quantity) })) ?? [];
    const normalize = (value) => String(value ?? "").toLocaleLowerCase("sr").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/g, "dj");
    const filteredItems = items.filter((item) => normalize(`${item?.basic_data?.name ?? ""} ${item?.basic_data?.sku ?? ""}`).includes(normalize(search.trim())));

    return (
        <MainCard>
            <SidebarHeader title={t("global-header-wishlist-title")} icon={icons.wish_list} mobileOnly />
            <div className="page-container">
                <div className={`p page-content ${scss.wrapper}`}>
                    <div className={scss.heading}>
                        <div>
                            <h4 className={scss.title}>{t("global-header-wishlist-title")}</h4>
                            <p className={scss.count}>Sačuvani proizvodi: <strong>{items.length}</strong></p>
                        </div>
                        {items.length > 0 && <SearchBar search={search} setSearch={setSearch} placeholder="Pretražite sačuvane proizvode" onSubmit={(event) => event.preventDefault()} mobileVisible />}
                    </div>
                    <LoadingWrapper isLoading={isLoading}>
                        {items.length === 0 ? (
                            <EmptyState kind="wishlist" title="Lista želja je prazna" description="Trenutno nemate sačuvanih proizvoda." />
                        ) : filteredItems.length > 0 ? (
                            <ProductItems products={filteredItems} translateKey="wishlist-default" />
                        ) : (
                            <EmptyState kind="wishlist" title="Nema rezultata" description="Nema sačuvanih proizvoda za unetu pretragu."><button type="button" onClick={() => setSearch("")}>Obriši pretragu</button></EmptyState>
                        )}
                    </LoadingWrapper>
                </div>
            </div>
        </MainCard>
    );
};

export default WishlistPage;
